<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    <h2>Dodaj transakcję</h2>
  </div>


  <div  fxFlex="100">
    <app-dict-partners label="Partner" [control]="partnerControl" [multiple]="false" [required]="true"></app-dict-partners>
  </div>

  <div fxLayout="column" fxFlex="100" *ngFor="let formGroup of formArray; index as i" [formGroup]="formGroup">
    <div fxLayout="row" fxLayoutAlign="space-between center">
    <h4>Wprowadź dane polisy</h4>
      <button *ngIf="i!==0" (click)="removeRepresentation(i)" mat-icon-button color="warn">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div fxFlex="100">
      <app-dict-insurance-companies [multiple]="false" [required]="true" label="TU"  formControlName="insuranceCompany"></app-dict-insurance-companies>
    </div>

    <div fxFlex="100" >
      <mat-form-field fxFlex="100" >
        <mat-label> Numer polisy </mat-label>
        <input [required]="true" name="policyNumber"  matInput placeholder="Numer polisy"   formControlName="policyNumber" >
        <mat-error *ngIf="formGroup.get('policyNumber').hasError('required')">To pole jest wymagane</mat-error>
        <mat-error></mat-error>
      </mat-form-field>
    </div>

    <div fxFlex="100" >
      <mat-form-field fxFlex="100">
        <mat-label>Numer rachunku bankowego</mat-label>
        <input
          prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
          matInput placeholder="PL 27 1140 2004 0000 3002 0135 5387"
          formControlName="accountNumber">
        <mat-error *ngIf="formGroup.hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
        <mat-error *ngIf="formGroup.getError('vatPayerControl')">Numer rachunku bankowego jest inny niż w rejestrze płatników VAT</mat-error>
      </mat-form-field>
    </div>

    <div fxFlex="100" fxLayoutGap="15px">
      <mat-form-field fxFlex="100">
        <mat-label>Kwota</mat-label>
        <input [required]="true" matInput placeholder="Kwota"   formControlName="sum">
        <mat-error *ngIf="formGroup.get('sum').hasError('required')">To pole jest wymagane</mat-error>
      </mat-form-field>

    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <h4>
      Jeśli przyjąłeś jedną płatność terminalem za więcej niż jedną polisę, kliknij przycisk „Dodaj polisę”, aby prawidłowo przypisać wszystkie polisy do tej transakcji.
    </h4>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="addTerminals()" mat-stroked-button color="primary">
      <mat-icon>add_box</mat-icon> <span> Dodaj</span>
    </button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button  mat-raised-button (click)="sendForm()" color="primary" [class.spinner]="processingRequest" [disabled]="processingRequest">Zapisz</button>
    <button mat-raised-button (click)="sendForm(true)" color="primary" [class.spinner]="processingRequest" [disabled]="processingRequest">Zapisz i dodaj kolejny</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
